import React,{useState,useEffect} from 'react';
import SubflowTemplateCreation from "./Subflow Template Contents/Subflow Template Creation";
import SubflowTemplateList from './Subflow Template Contents/Subflow Template List';


const SubflowTemplate = ({isCanvas, json,isSubflow,handleSubflowCanvasClick,createEvent, toolTipData}) => {
  console.log("in workflow tab and tooltipData ", toolTipData);

  const [createMinorTemplate, setCreateMinorTemplate] = useState(isCanvas);
  const [isWorkflow, setIsWorkflow] = useState(isSubflow);
  const [ Json, setJson] = useState(json);
const [subflowTempId,setSubflowTempId] = useState(0);
const [subflowTempName,setSubflowTempName] = useState('');
const [subflowTempReqBody,setSubflowTempReqBody] = useState({});
const [isEditSubflow,setIsEditSubflow] = useState(false);
const [isCloneSubflow,setIsCloneSubflow] = useState(false);

  const handleClick = () => {
    setJson({
      "nodes":[],
       "edges":[],
       "dropdownData":{
      "client": { label: "--select--", value: "--select--", dropdownId: "0" },
      "department": { label: "--select--", value: "--select--", dropdownId: "0" },
      "workflowName":{ label: "--select--", value: "--select--", dropdownId: "0" },
      "level":{ label: "--select--", value: "--select--", dropdownId: "0" },
    }});
    setSubflowTempId(0);
    setIsEditSubflow(false);
    setIsCloneSubflow(false);
    setCreateMinorTemplate(true);
    setSubflowTempName('');
    setSubflowTempReqBody('');
  };
const displayTemplateData=(templateData,id,requestBody,subflowTempName)=>{
  console.log("in display Template Data",id,templateData);
  setJson(templateData);
  setSubflowTempId(id);
  setSubflowTempReqBody(requestBody);
  setSubflowTempName(subflowTempName);
  setIsEditSubflow(true);
  setCreateMinorTemplate(true);
}

const displayCloneTemplateData=(templateData,id,requestBody,subflowTempName)=>{
  console.log("in display Clone Template Data",id,templateData);
  setJson(templateData);
  setSubflowTempId(id);
  setSubflowTempReqBody(requestBody);
  setSubflowTempName(subflowTempName);
  setIsCloneSubflow(true);
  setCreateMinorTemplate(true);
}
  const handleBackClick = () => {
    setCreateMinorTemplate(false); 
    //isWorkflow is changed to false on clicking back button to manage the state of the subflow template canvas  
    setIsWorkflow(false) ;
    setJson({
      "nodes":[],
       "edges":[],
       "dropdownData":{
      "client": { label: "--select--", value: "--select--", dropdownId: "0" },
      "department": { label: "--select--", value: "--select--", dropdownId: "0" },
      "workflowName":{ label: "--select--", value: "--select--", dropdownId: "0" },
      "level":{ label: "--select--", value: "--select--", dropdownId: "0" },
    }});
    setIsEditSubflow(false);
    setIsCloneSubflow(false);
  };

  useEffect(()=>{
   },[Json])


  return !createMinorTemplate ? (
    <>
      <SubflowTemplateList
        onHandleClick={handleClick}
        displayTemplateData={displayTemplateData}
        displayCloneTemplateData={displayCloneTemplateData}
        toolTipData={toolTipData}
      />
    </>
  ) : (
    // have to change the name of json
    <>
      <SubflowTemplateCreation
        onBackClick={handleBackClick}
        json={Json}
        isSubflow={isWorkflow}
        workflowName={Json.dropdownData.workflowName.label ??  '--select--'}
        level={Json.dropdownData.level.label ??  '--select--'}
        subflowTempId={subflowTempId}
        subflowReqBody={subflowTempReqBody}
        subflowTempName={subflowTempName}
        isEditSubflow={isEditSubflow}
        isCloneSubflow={isCloneSubflow}
        handleSubflowCanvasClick={handleSubflowCanvasClick}
        createEvent={createEvent}
      />
    </>
  );
};
export default SubflowTemplate;